export const BLACKLIST_ERROR_CODES: string[] = [
  'ERR_NETWORK' // Muting this reporting for network errors as it's consuming too much occurence in Rollbar
];

export const BLACKLIST_ERROR_TYPES: string[] = [
  'timeout' // Muting this reporting for timeouts as it's consuming too much occurence in Rollbar
];